import { createFileRoute } from "@tanstack/react-router";
import TermsAndConditions from "@/pages/TermsAndConditions";

export const Route = createFileRoute("/terms-and-conditions")({
  head: () => ({
    meta: [
      { title: "Terms & Conditions | Exeter Flow Screeds" },
      {
        name: "description",
        content:
          "Terms and Conditions for liquid screed supply and installation services by Exeter Flow Screeds Ltd across Exeter, Devon & Somerset.",
      },
      {
        property: "og:title",
        content: "Terms & Conditions | Exeter Flow Screeds",
      },
      {
        property: "og:description",
        content:
          "Terms and Conditions for liquid screed supply and installation services by Exeter Flow Screeds Ltd across Exeter, Devon & Somerset.",
      },
      {
        property: "og:url",
        content: "https://exeterflowscreed.co.uk/terms-and-conditions",
      },
      {
        name: "twitter:title",
        content: "Terms & Conditions | Exeter Flow Screeds",
      },
      {
        name: "twitter:description",
        content:
          "Terms and Conditions for liquid screed supply and installation services by Exeter Flow Screeds Ltd across Exeter, Devon & Somerset.",
      },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://exeterflowscreed.co.uk/terms-and-conditions",
      },
    ],
  }),
  component: TermsAndConditions,
});
